"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateVideoElement;

var _scrollToMarker = _interopRequireDefault(require("../scrollToMarker"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable no-param-reassign */


function updateVideoElement(_ref) {
  var videoEl = _ref.videoEl,
      newTime = _ref.newTime,
      newPlaybackRate = _ref.newPlaybackRate,
      onUpdate = _ref.onUpdate,
      forceScroll = _ref.forceScroll,
      currentClip = _ref.currentClip,
      _ref$videoAction = _ref.videoAction,
      videoAction = _ref$videoAction === void 0 ? 'play' : _ref$videoAction;
  var hasNewTime = !Number.isNaN(Number(newTime));

  if (!videoEl) {
    return;
  }

  if (hasNewTime) {
    // $FlowFixMe hasNewTime checks that newTime is a valid number
    videoEl.currentTime = newTime;
  }

  if (newPlaybackRate) {
    videoEl.playbackRate = newPlaybackRate;
  }

  if (hasNewTime || videoAction === 'pause' || forceScroll) {
    (0, _scrollToMarker.default)();
  }

  if (currentClip && !currentClip.isEmpty && !currentClip.isImage && currentClip.isTranscoded) {
    var video = videoEl;
    video[videoAction]();
    return;
  }

  if (onUpdate) {
    onUpdate();
  }
}
/* eslint-enable no-param-reassign */